import {
	Vector3,
	Color,
	Vector2
} from 'three';

const colorData = {
	envirmentIndex:12,
	envirmentBrightNess: 2.0,
	envirmentRotation: 1.5707963267948966,
	diamond: [{
		// 白
		colorCorrection: new Vector3(1, 1, 1),
		boostFactors: new Vector3(3, 3, 3),
		envMapIntensity: 0.5,
		n2: 2.4,
		distanceOffset: 0,
		normalOffset: 0.,
		squashFactor: 1,
		rIndexDelta:0.005,
		colorRGBIntencity: 0.5
	},
	{
		colorCorrection: new Vector3(0.15,0.4,0.5),
		boostFactors: new Vector3(1, 1, 1),
		envMapIntensity:0.8,
		n2: 1.5,
		distanceOffset: 0,
		normalOffset: 0.,
		squashFactor:1,
		rIndexDelta:0.0,
		colorRGBIntencity: 2
		// 海宝蓝

	},
	{
		// 红宝石
		colorCorrection: new Vector3(1,0.0,0.0),
		boostFactors: new Vector3(1, 1, 1),
		envMapIntensity:0.6,
		n2: 1.8,
		distanceOffset: 0,
		normalOffset: 0.,
		squashFactor:0.9,
		rIndexDelta:0.001,
		colorRGBIntencity: 1
	},
	{
		// 黄宝石
		colorCorrection: new Vector3(5,4,1.3),
		boostFactors: new Vector3(1, 1, 1),
		envMapIntensity:0.6,
		n2: 2.4,
		distanceOffset: 0,
		normalOffset: 0.,
		squashFactor:0.9,
		rIndexDelta:0.001,
		colorRGBIntencity: 0.5
	},
	{
		// 蓝宝石
		colorCorrection: new Vector3(0,0.4305,1),
		boostFactors: new Vector3(1, 1, 1),
		envMapIntensity:0.5,
		n2: 1.8,
		distanceOffset: 0,
		normalOffset: 0.,
		squashFactor:0.9,
		rIndexDelta:0.001,
		colorRGBIntencity: 1
	},
	{
		// 粉宝石
		colorCorrection: new Vector3(1.6,0.4,0.8),
		boostFactors: new Vector3(1, 1, 1),
		envMapIntensity:0.8,
		n2: 1.6,
		distanceOffset: 0,
		normalOffset: 0.,
		squashFactor:0.9,
		rIndexDelta:0.001,
		colorRGBIntencity: 1
	},
	{
		// 紫宝石
		colorCorrection: new Vector3(1.7,0.6,1.8),
		boostFactors: new Vector3(1, 1, 1),
		envMapIntensity:0.5,
		n2: 1.6,
		distanceOffset: 0,
		normalOffset: 0.,
		squashFactor:0.9,
		rIndexDelta:0.001,
		colorRGBIntencity: 0.5
	},
	{
		// 淡粉钻
		colorCorrection: new Vector3(1.4,0.8,0.8),
		boostFactors: new Vector3(1, 1, 1),
		envMapIntensity:0.6,
		n2: 1.7,
		distanceOffset: 0,
		normalOffset: 0.,
		squashFactor:0.9,
		rIndexDelta:0.0,
		colorRGBIntencity: 2
	},
	{
		// 绿宝石
		colorCorrection: new Vector3(0.4,1.5,0.4),
		boostFactors: new Vector3(1, 1, 1),
		envMapIntensity:0.6,
		n2: 1.6,
		distanceOffset: 0,
		normalOffset: 0.,
		squashFactor:0.9,
		rIndexDelta:0.,
		colorRGBIntencity: 0.5
	},
	{
		// 默认
		colorCorrection: new Vector3(1, 1, 1),
		boostFactors: new Vector3(3, 3, 3),
		envMapIntensity: 0.5,
		n2: 2.4,
		distanceOffset: 0,
		normalOffset: 0.,
		squashFactor: 1,
		rIndexDelta:0.005,
		colorRGBIntencity: 0.5
	},
	],
	"RingMConfig": {
        "materials": [{
                "isPBRShaderMaterial": true,
                "_MaterialType": 0,
                "normalScale": [1, 1],
                "bumpScale": 1,
                "uEnvironmentTransform": [6.123233995736766e-17, 0, -1, 0, 0, 1, 0, 0, 1, 0, 6.123233995736766e-17, 0, 0, 0, 0, 1],
                "emissiveIntensity": -0.1,
                "uSpecularF0Factor": 0.5,
                "uClearCoatF0": 1,
                "uMultiplyLightMap": 0,
                "emissive": [1, 1, 1],
                "roughness": 0.15,
                "metalness":1,
                "uEnvironmentExposure": 2.0,
                "envMapIntensity": 1,
                "opacity": 1,
                "uDrawOpaque": 0,
                "uAOPBROccludeSpecular": 1,
                "uNormalMapFlipY": 0,
                "uNormalMapFactor": 1,
                "diffuse": [0.8431372549019608, 0.8431372549019608, 0.8431372549019608],
                "aoMapIntensity": 1
            }, 
            {
                "isPBRShaderMaterial": true,
                "_MaterialType": 1,
                "uEmitMultiplicative": 0,
                "normalScale": [1, 1],
                "bumpScale": 1,
                "uEnvironmentTransform": [6.123233995736766e-17, 0, -1, 0, 0, 1, 0, 0, 1, 0, 6.123233995736766e-17, 0, 0, 0, 0, 1],
                "emissiveIntensity": -0.1,
                "uSpecularF0Factor": 0.5,
                "uClearCoatF0": 1,
                "uMultiplyLightMap": 0,
                "emissive": [1, 1, 1],
                "roughness": 0.15,
                "metalness":1,
                "uEnvironmentExposure": 2.4,
                "envMapIntensity": 1,
                "opacity": 1,
                "uDrawOpaque": 0,
                "uAOPBROccludeSpecular": 1,
                "uNormalMapFlipY": 0,
                "uNormalMapFactor": 1,
                "diffuse": [0.9725490196078431, 0.7215686274509804, 0.5686274509803921],
                "aoMapIntensity": 1
            },
            {
                "_MaterialType": 2,
                "uEmitMultiplicative": 0,
                "normalScale": [1, 1],
                "bumpScale": 1,
                "uEnvironmentTransform": [6.123233995736766e-17, 0, -1, 0, 0, 1, 0, 0, 1, 0, 6.123233995736766e-17, 0, 0, 0, 0, 1],
                "emissiveIntensity": -0.1,
                "uSpecularF0Factor": 0.5,
                "uClearCoatF0": 1,
                "uMultiplyLightMap": 0,
                "emissive": [1, 1, 1],
                "roughness": 0.15,
                "metalness":1,
                "uEnvironmentExposure": 2.4,
                "envMapIntensity": 1,
                "opacity": 1,
                "uDrawOpaque": 0,
                "uAOPBROccludeSpecular": 1,
                "uNormalMapFlipY": 0,
                "uNormalMapFactor": 1,
                "envMap": "https://p.gemcool.cn/asset_3d/Envirments/Envirment16/Envirment16.zip",
                "diffuse": [1, 0.7803921568627451, 0.44313725490196076],

                "aoMapIntensity": 1
            }
        ]
    },
	smashDiamond: {
		// 碎钻白
		colorCorrection: new Vector3(1, 1, 1),
		boostFactors: new Vector3(6, 6, 6),
		envMapIntensity: 1.,
		n2: 2.4,
		distanceOffset: 0,
		normalOffset: 0.,
		squashFactor: 0.8,
		rIndexDelta: 0.001,
		colorRGBIntencity: 0.2
	},
	// 组合款暂用
	tempSmashDiamond: {
		// 碎钻白
		colorCorrection: new Vector3(1, 1, 1),
		boostFactors: new Vector3(4, 4, 4),
		envMapIntensity: 1.,
		n2: 2.4,
		distanceOffset: 0,
		normalOffset: 0.,
		squashFactor: 0.8,
		rIndexDelta: 0.001,
		colorRGBIntencity: 0.2
	}
};
export {
	colorData
};